import { IconWrapper } from '../runtime';
export default IconWrapper('mind_mapping_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#009BBA"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#0086A0"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#09B2D4"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#009BBA"
    }
  }), h("path", {
    "attrs": {
      "d": "M14.7188 3.65625V8.53125H11.25V6.65625H12.8438V5.53125H8.0625L9.9375 3.65625H14.7188Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.65625 6.65625H9.84375V11.7188H3.65625V6.65625ZM5.53125 8.53125V9.84375H7.96875V8.53125H5.53125Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.25 11.7188H12.8438V12.8438H8.0625L9.9375 14.7188H14.7188V9.84375H11.25V11.7188Z",
      "fill": "white"
    }
  })]);
});